/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_No_Duration_ToastInputs */



/**
* | output |
* | --- |
* | "Unable to segment Event Group. No duration detected." |
*
* @param {Segment_Event_Group_No_Duration_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_no_duration_toast = /** @type {((inputs?: Segment_Event_Group_No_Duration_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_No_Duration_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de segmenter le groupe d'evenements. Aucune duree detectee.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisgruppe konnte nicht segmentiert werden. Keine Dauer erkannt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile segmentare il gruppo di eventi. Nessuna durata rilevata.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось выделить группу событий. Продолжительность не определена.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se puede segmentar el grupo de eventos. No se detectó duración.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("无法对事件组进行分段。未检测到持续时间。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント グループをセグメント化できません。期間が検出されませんでした。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट ग्रुप को सेगमेंट करने में असमर्थ। कोई अवधि निर्धारित नहीं हुई।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não foi possível segmentar o grupo de eventos. Nenhuma duração detectada.")
	return /** @type {LocalizedString} */ ("Unable to segment Event Group. No duration detected.")
});